import { useSelector } from 'react-redux';
import { getProfileCertificates } from '@client/context/redux/redux';
import { isCertified } from '@client/context/utils/certificates';

export function useCertificationValidator(): (productCertificates: string[]) => boolean {
  const debitorCertificates = useSelector(getProfileCertificates);

  return (productCertificates) => isCertified(productCertificates, debitorCertificates);
}
